import React from 'react';

import { AppKey } from '../../../../libs/apps';
import { ISession } from '../../../../libs/session';

interface SessionTableContextValue {
  openInvalidation: (
    appKey: AppKey,
    sessionModel: string,
    session: ISession
  ) => any;
  closeInvalidation: (...any) => any;
}

const SessionTableContext = React.createContext<SessionTableContextValue>({
  openInvalidation: null,
  closeInvalidation: null
});

export const SessionTableProvider: React.FC<{
  value: SessionTableContextValue;
}> = ({ value, ...props }): JSX.Element => {
  return <SessionTableContext.Provider value={value} {...props} />;
};

export function useSessionTable(): SessionTableContextValue {
  const context = React.useContext(SessionTableContext);
  if (context === undefined) {
    throw new Error(
      'useSessionTable must be used within a SessionTableProvider'
    );
  }
  return context;
}
